module.exports = __webpack_public_path__ + "z/simple-mobile.f5dc51ed.jpg";